import { connect } from 'react-redux';
import { connect as connectRefetch } from 'react-refetch';
import { compose } from 'recompose';

import { getProjectsCached } from '../../redux/actions/project';
import { getProjectIdFromRoute } from '../../redux/projects/projects.selectors';
import { StoreState } from '../../redux/reducers/store.types';
import { Dispatch } from '../../redux/redux.types';
import { getSelectedOrganizationId } from '../../selectors/organizations/organizations';
import { RouterContext } from '../../types/router';

import { getReplicationsCached } from './redux/replications-list.actions';
import { ReplicationsLazyLoadContainer } from './replications.lazy';

export interface ReplicationsDataLoaderOwnProps {
  router: RouterContext;
}

export interface ReplicationsDataLoaderStateProps {
  organizationId: string;
  projectId: string | undefined;
}

export interface ReplicationsDataLoaderDispatchProps {
  getProjectsCached(organizationId: string): void;
  getReplicationsCached(): void;
}

export interface ReplicationsDataLoaderRefetchProps {
  getProjectsFetch: {
    value(): Promise<void>;
    comparison: string;
  };
  getReplicationsFetch: {
    value(): Promise<void>;
    comparison: string;
  };
}

export type ReplicationsDataLoaderInnerProps = ReplicationsDataLoaderOwnProps &
  ReplicationsDataLoaderStateProps &
  ReplicationsDataLoaderDispatchProps &
  ReplicationsDataLoaderRefetchProps;

export const ReplicationsDataLoader = compose<
  ReplicationsDataLoaderInnerProps,
  {}
>(
  connect(
    (state: StoreState): ReplicationsDataLoaderStateProps => ({
      organizationId: getSelectedOrganizationId(state),
      projectId: getProjectIdFromRoute(state),
    }),
    (
      dispatch: Dispatch,
      { router }: ReplicationsDataLoaderOwnProps,
    ): ReplicationsDataLoaderDispatchProps => ({
      getProjectsCached: (organizationId: string) => {
        dispatch(getProjectsCached(organizationId));
      },
      getReplicationsCached: () => {
        dispatch(getReplicationsCached(router));
      },
    }),
  ),
  connectRefetch(
    ({
      getProjectsCached,
      getReplicationsCached,
      organizationId,
      projectId,
    }): ReplicationsDataLoaderRefetchProps => ({
      getProjectsFetch: {
        value: () => getProjectsCached(organizationId),
        comparison: organizationId,
      },
      getReplicationsFetch: {
        value: () => getReplicationsCached(),
        comparison: `${organizationId}_${projectId}`,
      },
    }),
  ),
)(ReplicationsLazyLoadContainer);
